var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.columns.length)?_c('SalesReportTemplate',{attrs:{"title":"Sales Report By Location","permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_SALES_BY_LOCATION,"columns":_vm.columns,"fetchRoute":"/reports/sales-by-location","reportTypeCode":_vm.REPORT_MASTER_CODES.SALES_BY_LOCATION}}):_c('div',[_vm._v("Loading...")])
}
var staticRenderFns = []

export { render, staticRenderFns }